import { TREND_SUMMARIES, TRENDCALLS, TRENDING_TOPICS } from '@/model/views/tabs'

export default {
    tabs: {
        [TRENDCALLS]: 'Trendcalls',
        [TRENDING_TOPICS]: 'Trending Topics',
        [TREND_SUMMARIES]: 'Trend Summaries'
    }
}
